import React from 'react';
import './App.css';
import NetworkBubbles from './NetworkBubbles';


const App: React.FC = () => {
  return (
    <div className="App"> 
      <NetworkBubbles />
    </div>
  );
};

export default App;
